import {
  HARDENING_CLUSTERS as HARDENING_CLUSTERS_CONST,
  HARDENING_POLICY_STATUS as HARDENING_POLICY_STATUS_CONST,
} from '@/lib/constants/hardening'

export const HARDENING_CLUSTERS = {
  [HARDENING_CLUSTERS_CONST.AUDIT]: 'Audit',
  [HARDENING_CLUSTERS_CONST.REMOTE_ACCESS]: 'Remote Access',
  [HARDENING_CLUSTERS_CONST.PASSWORD_SECURITY]: 'Password Policy',
  [HARDENING_CLUSTERS_CONST.DISK_ENCRYPTION]: 'Disk Encryption',
  [HARDENING_CLUSTERS_CONST.SCREEN_LOCK]: 'Screen Lock',
  [HARDENING_CLUSTERS_CONST.PRIVILEGE_PROTECTION]: 'Privilege Protection',
  [HARDENING_CLUSTERS_CONST.HOST_FIREWALL]: 'Firewall',
}

export const HARDENING_POLICY_STATUS = {
  [HARDENING_POLICY_STATUS_CONST.PASSED]: 'Passed',
  [HARDENING_POLICY_STATUS_CONST.WARNING]: 'Warning',
  [HARDENING_POLICY_STATUS_CONST.FAILED]: 'Failed',
  [HARDENING_POLICY_STATUS_CONST.NOT_APPLICABLE]: 'Not Applicable',
}

export const HARDENING_ASSET_TYPES = {
  SERVER: 'Server',
  LAPTOP: 'Laptop',
}

export const HARDENING_ASSET_TABLE = {
  SERVERS_TITLE: 'Servers Hardening',
  LAPTOPS_TITLE: 'Laptops Hardening',
  NAME: 'Name',
  SEARCH_PLACEHOLDER: 'Search asset...',
}

export const HARDENING_ASSETS_DETAILS = {
  POLICY_REMEDIATION: 'Remediation',
  OS: 'OS',
  LAST_UPDATED: 'Last Updated',
  TYPE: 'Type',
  POLICIES_GROUPED_BY_CLUSTERS: 'Policies by cluster',
  NO_POLICIES_ASSIGNED: 'No policies assigned',
}
